import { render } from "./RegisterProduct.vue?vue&type=template&id=29bdbeea&scoped=true"
import script from "./RegisterProduct.js?vue&type=script&lang=js"
export * from "./RegisterProduct.js?vue&type=script&lang=js"

import "./RegisterProduct.scss?vue&type=style&index=0&id=29bdbeea&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29bdbeea"]])

export default __exports__